import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { HomePageContainerState } from './homepage';

const initialState: HomePageContainerState = {
  default: 'default',
};

export const homepageSlice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setDefault: (state, action: PayloadAction<string>) => {
      state.default = action.payload;
    },
  },
});

export const {
  setDefault,
} = homepageSlice.actions;

export default homepageSlice.reducer;
